// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A tool for making Google form embed scripts usable on our websites.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Google Form Embedder",
  id: "google-form-embedder",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/google-form-embedder/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(// Set webpackChunkName to dynamic import PhotoGalleryConfigTool in order to get all the css styles for the image crop.
      /* webpackChunkName: "PhotoGalleryConfigTool" */ "app/components/tools/GoogleFormEmbedderTool/GoogleFormEmbedderTool"),
    loading: DynamicImportLoader,
    modules: ["GoogleFormEmbedderTool"]
  })
};

export default CONFIG;
